import { UserActivitySettingsResponse } from './types';

export const handleLoadUserActivitySettingsSuccess = (
  state: any,
  response: UserActivitySettingsResponse,
) => ({
  ...state,
  ...response,
  loadingState: false,
});
